import { Box } from "@mui/material";

interface IImage {
  source: string;
}

const Image: React.FC<IImage> = ({ source }) => {
  return <Box component="img" src={`${process.env.REACT_APP_START_URL}${source}`} />;
};

export default Image;
